import { render, staticRenderFns } from "./TripsMap.vue?vue&type=template&id=48d65348"
import script from "./TripsMap.vue?vue&type=script&lang=js"
export * from "./TripsMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports